import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { BiCaretLeft } from "react-icons/bi";
import { TbCurrencyRupee } from "react-icons/tb";
import CartCard from "./CartCard";
import { SERVER_PATH } from "../../config/env";
import { userInfo } from "../../utils/appInfo";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import { errorToaster, successToaster } from "../../utils/index";
import { UserContext } from "./../../context/userContext";

export default function Cart() {
  const { updateUserData } = useContext(UserContext);
  const [data, setData] = useState([]);
  const [cartData, setCartData] = useState([]);
  const [taxData, setTaxData] = useState([]);
  let [cartValue, setCartValue] = useState(0);
  const [userData, setUserData] = useState({});
  const [courierPrice, setCourierPrice] = useState([]);
  const [stateData, setStateData] = useState({});
  const [isChecked, setIsChecked] = useState(0);

  // ✅ NEW (double order fix)
  const [isProcessing, setIsProcessing] = useState(false);

  const fetchData = async () => {
    try {
      const user = userInfo();
      if (!user?.email) return;

      const { data: cData = [] } = await axios.post(
        `${SERVER_PATH}get/cart.php`,
        {
          user_id: user.email,
        }
      );
      setData(cData);
      updateUserData({ cart: cData });
    } catch (error) {
      setData([]);
    }
  };

  const fetchStateData = async () => {
    const user = userInfo();
    if (!user?.email) return;

    await axios
      .post(`${SERVER_PATH}get/user.php`, {
        user_id: user.email,
      })
      .then((res) => {
        setStateData(res.data[0] || {});
      });
  };

  useEffect(() => {
    if (stateData?.state) courierPriceData(stateData);
  }, [stateData]);

  const postCartData = (i) => {
    if (!userData?.email || !data[i]) return;

    axios
      .post(`${SERVER_PATH}put/cart.php`, {
        user_id: userData.email,
        product_id: data[i].product_id,
        quantity: data[i].quantity,
      })
      .then((res) => {
        setCartData(res.data);
      });
  };

  useEffect(() => {
    let value = 0;
    data.map((info) => {
      value = value + info.quantity * info.offer_price;
    });
    setCartValue(value);
  }, [data]);

  const removeProduct = async (id) => {
    if (!userData?.email) return;

    await axios
      .post(`${SERVER_PATH}delete/cart.php`, {
        user_id: userData.email,
        product_id: id,
      })
      .then((res) => {
        fetchData();
        errorToaster({ msg: "Item removed from your cart" });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const checkoutProduct = async () => {
    // ✅ prevent double click
    if (!userData?.email || isProcessing) return;

    setIsProcessing(true);

    let productID = data.map((d) => d.product_id);
    let quantity = data.map((d) => d.quantity);
    let product_name = data.map((d) => d.product_name);

    let deliveryCost =
      isChecked === 1
        ? 0
        : stateData?.state !== "0"
        ? getDeliveryCost()
        : 0;

    deliveryCost =
      data.length == 1 &&
      data.find((val) => val.product_name == "Health And Wellness")
        ? 0
        : deliveryCost;

    let totalOrderCost = cartValue + deliveryCost;

    let payload = {
      user_id: userData.email,
      order_cost: totalOrderCost,
      product_id: productID,
      quantity: quantity,
      product_name: product_name,
    };

    await axios
      .post(`${SERVER_PATH}post/payment.php`, payload)
      .then((res) => {
        if (res?.data?.pay_url) {
          window.location.href = res.data.pay_url;
        } else {
          setIsProcessing(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsProcessing(false);
      });
  };

  const courierPriceData = async (val = {}) => {
    await axios
      .post(`${SERVER_PATH}get/delivery_cost.php`, {
        state: val.state,
      })
      .then((res) => {
        setCourierPrice(res.data[0] || {});
      })
      .catch((err) => console.log(err));
  };

  const getTaxData = () => {
    axios.post(`${SERVER_PATH}get/additional_cost.php`, {}).then((res) => {
      setTaxData(res.data[0] || {});
    });
  };

  useEffect(() => {
    axios
      .get(`${SERVER_PATH}get/free_delivery.php`, {
        params: { sno: "1" },
      })
      .then((response) => {
        if (response.data.length > 0) {
          const fetchedValue = Number(response.data[0].free);
          setIsChecked(fetchedValue);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const calculateBasePrice = (weight = 0) => {
    let cost = 0;
    if (!weight) return 0;

    if (weight <= 250) cost = courierPrice?.g250 || 0;
    else if (weight <= 500) cost = courierPrice?.g500 || 0;
    else if (weight <= 3000) {
      let remWeigh = weight - 500;
      let remCalc = Math.ceil(remWeigh / 500);
      cost = remCalc * (courierPrice?.upto3kg || 0) + Number(courierPrice?.g500 || 0);
    } else {
      let remCalc = Math.ceil(weight / 1000);
      cost = remCalc * (courierPrice?.above3kg || 0);
    }
    return cost;
  };

  const getDeliveryCost = () => {
    let weight = 0;
    data.map((item) => {
      let maxWeight = item.weight * item.quantity;
      weight = weight + maxWeight;
    });

    let accCost = calculateBasePrice(weight);
    accCost =
      Number(accCost) + (Number(accCost) * (taxData?.fuel || 0)) / 100;

    let netCost =
      Math.ceil(accCost) +
      (Math.ceil(accCost) * (taxData?.gst || 0)) / 100;

    return Math.ceil(netCost);
  };

  useEffect(() => {
    setTimeout(async () => {
      await fetchData();
      await fetchStateData();
      setUserData(userInfo() || {});
      getTaxData();
    }, 500);
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="h-100 h-custom productPage">
        <div className="container-fluid py-4 h-100">
          <div className="row d-flex justify-content-center align-items-center h-100">
            <div className="col">
              <div className="card">
                <div className="card-body p-4">
                  <div className="row">
                    <div className="col-lg-7">
                      <div className="mb-3">
                        <Link to="/" className="text-body text-decoration-none">
                          <BiCaretLeft
                            className="me-0"
                            style={{ fontSize: "1.5em", marginTop: "-5px" }}
                          />
                          <span>Continue shopping</span>
                        </Link>
                      </div>
                      <hr />

                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <div>
                          <p className="mb-1">Shopping cart</p>
                          <p className="mb-0">
                            You have {data.length} items in your cart
                          </p>
                        </div>
                      </div>

                      <CartCard
                        cartData={(i) => postCartData(i)}
                        data={data}
                        deleteValue={removeProduct}
                        setData={setData}
                      />
                    </div>

                    <div className="col-lg-5">
                      <div className="card bg-success text-white rounded-3">
                        <div className="card-body">
                          <h4 className="text-uppercase">Price Details</h4>
                          <hr className="my-3" />

                          <div className="d-flex justify-content-between">
                            <p className="mb-2 text-uppercase">sub total</p>
                            <p className="mb-2">
                              <TbCurrencyRupee style={{ marginTop: "-3px" }} />
                              {cartValue}
                            </p>
                          </div>

                          <div className="d-flex justify-content-between">
                            <p className="mb-2 text-uppercase">
                              {isChecked === 1
                                ? "Free Delivery"
                                : "Delivery charges"}
                            </p>
                            <p className="mb-2">
                              <TbCurrencyRupee />
                              {isChecked === 1
                                ? 0
                                : stateData?.state !== "0"
                                ? getDeliveryCost()
                                : 0}
                            </p>
                          </div>

                          <hr className="my-3" />

                          <div className="d-flex justify-content-between mb-2">
                            <p className="mb-2 text-uppercase">Total Price</p>
                            <p className="mb-2">
                              <TbCurrencyRupee />
                              {stateData?.state !== "0"
                                ? cartValue +
                                  (isChecked === 1 ? 0 : getDeliveryCost())
                                : cartValue}
                            </p>
                          </div>

                          {/* ✅ FIXED BUTTON */}
                          <button
                            disabled={!cartValue || isProcessing}
                            type="button"
                            className="btn btn-light btn-block btn-sm"
                            onClick={() => {
                              if (stateData?.state == "0") {
                                // alert(
                                //   "Please provide your address in your profile page"
                                // );
                                        errorToaster({ msg: "Please provide your address in your profile page" });
                              } else {
                                checkoutProduct();
                              }
                            }}
                          >
                            {isProcessing ? "Processing..." : "Checkout"}
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ToastContainer />
    </>
  );
}